import { render } from "./AboutSystem.vue?vue&type=template&id=4dee768b&scoped=true&ts=true"
import script from "./AboutSystem.vue?vue&type=script&lang=ts"
export * from "./AboutSystem.vue?vue&type=script&lang=ts"

import "./AboutSystem.vue?vue&type=style&index=0&id=4dee768b&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dee768b"]])

export default __exports__